<div class="allContent">
  <div class="labels">
    <h1 style="font-size: 25px;">Configurações</h1>
    <hr>
    <h2 style="font-size: 15px; font-weight: 400;">
    Clique e arraste para ordenar os campos
  </h2>
  </div>
  <div style="display: flex; justify-content: center; padding-top: 15px;">
    <button
      style="width: 100%; background: #f3f3f3;"
      mat-button
      (click)="marcarTodos()">
      {{ obterLabelBotaoMarcarDesmarcarTodos }}
    </button>
  </div>

  <div style="overflow: auto;">
    <div
      cdkDropList
      class="example-list"
      (cdkDropListDropped)="drop($event)"
      (cdkDropListDropped)="ordenarListaDrop()">
      <div
        class="example-box"
        *ngFor="let lista of listaDeItens;"
        cdkDrag>
        <div
          class="listaDragAndDrop"
          *ngIf="!lista.ocultoPorParametro && lista.visivel">
          <mat-checkbox
            (change)="alterouValorCheckBox()"
            [(ngModel)]="lista.check">
            {{ lista.label }}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div
      class="buttons"
      style="display: flex; justify-content: center;">
      <button
        mat-raised-button
        color="primary"
        (click)="salvarConfiguracao()">
        <i class="fas fa-save"></i>
        Salvar
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="resetarConfiguracao()">
        <i class="fas fa-backward"></i>
        Restaurar configuração
      </button>
      <button
        mat-raised-button
        color="warn"
        mat-dialog-close>
        <i class="la la-times"></i>
        Fechar
      </button>
    </div>
  </div>
</div>
